import React, { useEffect, useState, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import { getMaintenance } from '../apiCalls';
import { StoreContext } from '../Store';
import DOMPurify from 'dompurify';
import LimitedAccessBannerStrip from './LimitedAccessBannerStrip';
import './MaintenanceBanner.css';

const MaintenanceBanner = ({ previewData, isLimitedAccess = false }) => {
  const store = useContext(StoreContext);

  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [banner, setBanner] = useState({});

  const htmlSanitizeConfig = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'u', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target'],
  };

  const onHide = () => {
    setShowMoreInfo(false);
  };

  const fetchData = async () => {
    const [data] = await getMaintenance();
    if (data) {
      setBanner(data);
    }
  };

  useEffect(() => {
    if (previewData || isLimitedAccess) {
      return;
    }
    fetchData();
  }, [previewData, isLimitedAccess]);

  useEffect(() => {
    // fetch data if maintenanceRefresh is triggered (i.e. from the MaintenanceDetails component)
    if (store.maintenanceRefresh[0] && !previewData && !isLimitedAccess) {
      fetchData();
      store.maintenanceRefresh[1](false);
    }
  }, [store.maintenanceRefresh[0], previewData, isLimitedAccess]);

  useEffect(() => {
    if (previewData) {
      setBanner({ ...previewData });
    }
  }, [previewData]);

  const resolved = previewData ? { ...previewData } : banner;

  return (
    <>
      {isLimitedAccess ? (
        <LimitedAccessBannerStrip />
      ) : (
        resolved.enabled && (
          <div className="maintenance-banner">
            <p>
              {resolved.bannerText}
              {resolved.moreInfo != '' && (
                <button type="button" className="more-info-button" onClick={() => setShowMoreInfo(true)}>
                  [More info]
                </button>
              )}
            </p>
          </div>
        )
      )}

      <Modal centered show={showMoreInfo} onHide={onHide} size="lg" className="maintenance-banner-modal">
        <section>
          <Modal.Body>
            <div className="py-3 px-3">
              <b>{resolved?.bannerText}</b>
            </div>
            <div
              className="py-3 px-3"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(resolved?.moreInfo, htmlSanitizeConfig) }}
            />
            <div className="d-flex flex-row push-left-right pb-3 px-3">
              <span></span>
              <button
                className="blue-button-newload"
                onClick={() => {
                  setShowMoreInfo(false);
                }}
                style={{ display: 'flex', borderRadius: '10px', marginTop: 0 }}
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </section>
      </Modal>
    </>
  );
};

export default MaintenanceBanner;
